<nb-card class="delete-dialog" [nbSpinner]="submitState==='submitting'">
    <nb-card-header>
        <morva-icons icon="close" class="cursor-pointer icon-18 ms-2" (click)="closeDialog('noAction')"></morva-icons>
        {{title}}
    </nb-card-header>
    <nb-card-body>
        <div style="line-height: 1rem">{{message}}</div>
    </nb-card-body>
    <div class="nb-card-footer">
        <button nbButton
                (click)="shouldDeleteTemporaryDashboard ? closeDialog('deleteTempDashboard') : closeDialog('noAction')"
                class="cancel-button">
            خیر
        </button>
        <button nbSpinnerStatus="basic" nbButton (click)="saveDashboard()" data-testid="confirm-button"
                class="confirm-button">
            بله
        </button>
    </div>
</nb-card>
